import React from 'react'; 
export default function Version() { 
return (<pre>
FriCo-peli, versio: ti 08.09.2026 klo 09:36:17 
<br/>
-Muutokset1 <br/>
-frico.app <br/>
<br/></pre>)

} 